import React, { useEffect, useState } from 'react';
import { apiFetch } from './api';

function AdminBilling() {
  const [data, setData] = useState({ subscriptions: [], mrr: 0, ai_usage: [] });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchAdminBilling();
  }, []);

  const fetchAdminBilling = async () => {
    try {
      setLoading(true);
      const res = await apiFetch('/admin/billing');
      const json = await res.json();
      setData({
        subscriptions: Array.isArray(json.subscriptions) ? json.subscriptions : [],
        mrr: typeof json.mrr === 'number' ? json.mrr : 0,
        ai_usage: Array.isArray(json.ai_usage) ? json.ai_usage : [],
      });
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="stat-card" style={{ padding: '2rem' }}>Carregando dados financeiros...</div>;

  return (
    <div className="animate-fade">
      <div className="stats-grid" style={{ marginBottom: '2.5rem' }}>
        <div className="stat-card" style={{ display: 'flex', alignItems: 'center', gap: '1.2rem' }}>
          <div className="stat-icon" style={{ background: 'rgba(74, 222, 128, 0.1)', color: '#4ade80', margin: 0 }}>💳</div>
          <div>
            <div className="stat-value" style={{ margin: 0, lineHeight: 1.1 }}>R$ {data.mrr.toFixed(2)}</div>
            <div className="stat-label">MRR Real (Tenants Pagantes)</div>
          </div>
        </div>
        <div className="stat-card" style={{ display: 'flex', alignItems: 'center', gap: '1.2rem' }}>
          <div className="stat-icon" style={{ background: 'rgba(56, 189, 248, 0.1)', color: '#38bdf8', margin: 0 }}>🏢</div>
          <div>
            <div className="stat-value" style={{ margin: 0, lineHeight: 1.1 }}>{data.subscriptions.length}</div>
            <div className="stat-label">Assinaturas Criadas</div>
          </div>
        </div>
      </div>

      <div className="stat-card" style={{ padding: '2rem', marginBottom: '2.5rem' }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '2rem' }}>
          <div>
            <h2>Gestão de Faturamento Global</h2>
            <p className="stat-label">Monitoramento de planos e saúde financeira do SaaS</p>
          </div>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>ID Assin.</th>
                <th>Oficina (Tenant)</th>
                <th>Plano</th>
                <th>Status Stripe</th>
                <th>Data de Início</th>
              </tr>
            </thead>
            <tbody>
              {data.subscriptions.map((sub, idx) => (
                <tr key={idx}>
                  <td style={{ color: '#94a3b8' }}>#{sub[0]}</td>
                  <td style={{ fontWeight: '600', color: '#fbbf24' }}>{sub[1]}</td>
                  <td>
                    {sub[2] === 'premium_monthly' ? 'Mensal' : sub[2] === 'premium_yearly' ? 'Anual' : sub[2]}
                  </td>
                  <td>
                    {sub[3] === 'active' ? (
                      <span style={{ color: '#4ade80' }}>● Ativo</span>
                    ) : (
                      <span style={{ color: '#ef4444' }}>● {sub[3].toUpperCase()}</span>
                    )}
                  </td>
                  <td>{new Date(sub[4]).toLocaleDateString()}</td>
                </tr>
              ))}
              {data.subscriptions.length === 0 && (
                <tr>
                  <td colSpan="5" style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8' }}>Nenhuma assinatura ativa via Stripe ainda.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* QUADRO DE CONSUMO DE IA (Faturamento Híbrido) */}
      <div className="stat-card" style={{ padding: '2rem' }}>
        <div style={{ marginBottom: '2rem' }}>
          <h2>Quadro de Consumo de Modelos de IA (SaaS)</h2>
          <p className="stat-label">Monitoramento de consumo de tokens e custos de IA por Tenant</p>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>ID Oficina</th>
                <th>Oficina (Tenant)</th>
                <th>Chamadas IA</th>
                <th>Tokens Entrada</th>
                <th>Tokens Saída</th>
                <th>Custo Estimado (Global)</th>
              </tr>
            </thead>
            <tbody>
              {data.ai_usage.map((tenant, idx) => (
                <tr key={idx}>
                  <td style={{ color: '#94a3b8' }}>#{tenant.tenant_id}</td>
                  <td style={{ fontWeight: '600', color: '#60a5fa' }}>{tenant.tenant_name}</td>
                  <td>{tenant.calls}</td>
                  <td>{tenant.input_tokens.toLocaleString()}</td>
                  <td>{tenant.output_tokens.toLocaleString()}</td>
                  <td style={{ fontWeight: 'bold', color: tenant.estimated_cost > 0 ? '#4ade80' : '#f59e0b' }}>
                    {tenant.estimated_cost > 0 ? (
                      `USD ${tenant.estimated_cost.toFixed(5)}`
                    ) : (
                      <span style={{ fontSize: '0.85rem', color: '#a1a1aa', background: 'rgba(255, 255, 255, 0.05)', padding: '2px 6px', borderRadius: '4px' }}>
                        Chave Própria (BYOK)
                      </span>
                    )}
                  </td>
                </tr>
              ))}
              {data.ai_usage.length === 0 && (
                <tr>
                  <td colSpan="6" style={{ textAlign: 'center', padding: '2rem', color: '#94a3b8' }}>Nenhum log de consumo de IA registrado ainda.</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default AdminBilling;

